import script from "./form-slug.vue?vue&type=script&setup=true&lang=ts"
export * from "./form-slug.vue?vue&type=script&setup=true&lang=ts"

import "./form-slug.vue?vue&type=style&index=0&id=64a24903&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64a24903"]])

export default __exports__